<template>
  <div class="m-wrap m-wap">
    <Logo :extras="extras" />
    <Banner :extras="extras" />
    <!--<div class="logo">-->
    <!--<img src="../../assets/images/wap/logo.png" alt="" />-->
    <!--</div>-->
    <!--<div class="banner">-->
    <!--<img src="../../assets/images/wap/banner.png" alt="" />-->
    <!--</div>-->
    <!--<div class="content">-->
    <!--<div class="u-success">-->
    <!--<img src="../../assets/images/wap/icon-success.png" alt="" />-->
    <!--</div>-->
    <!--<div-->
    <!--class="t-success"-->
    <!--:style="{-->
    <!--color: extraItem.extras('successTitle.color'),-->
    <!--fontSize: pxOrVw(extraItem.extras('successTitle.size')),-->
    <!--fontWeight:-->
    <!--extraItem.extras('successTitle.weight') == 'default'-->
    <!--? '500'-->
    <!--: extraItem.extras('successTitle.weight'),-->
    <!--}"-->
    <!--&gt;-->
    <!--{{ extras | extra("successTitle.model") }}-->
    <!--</div>-->
    <!--<div-->
    <!--class="t-success-desc"-->
    <!--:style="{-->
    <!--color: extraItem.extras('successText.color'),-->
    <!--fontSize: pxOrVw(extraItem.extras('successText.size')),-->
    <!--fontWeight:-->
    <!--extraItem.extras('successText.weight') == 'default'-->
    <!--? '400'-->
    <!--: extraItem.extras('successText.weight'),-->
    <!--}"-->
    <!--&gt;-->
    <!--{{ extras | extra("successText.model") }}-->
    <!--</div>-->
    <!--</div>-->

    <SuccessCon
      :extras="extras"
      :platform="platform"
      :is-show-again="isShowAgain"
    />
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import Banner from "@/components/Banner.vue";
import SuccessCon from "@/components/SuccessCon.vue";
import mixinConfig from "../../mixin/config.js";
import mixinSuccess from "../../mixin/success.js";

export default {
  name: "WapSuccess",
  mixins: [mixinConfig, mixinSuccess],
  components: {
    Logo,
    Banner,
    SuccessCon,
  },
  data() {
    return {
      platform: "wap",
      isShowAgain: false,
    };
  },
};
</script>
